import { useIntl } from "react-intl";
import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import { ImageTypes } from "~enums/imageTypes.ts";
import { EntityTableColumns } from "~pages/Entities/EntitiesListPage/enums/entityTableColumns.ts";
import type { EntityTransformed } from "~pages/Entities/types/entityTransformed.ts";
import type { Image } from "~types/image.ts";

export const useGetEntitiesTableColumns = (): Array<DataTableColumn<EntityTransformed>> => {
  const { formatMessage } = useIntl();

  return [
    {
      key: EntityTableColumns.Image,
      title: formatMessage({ id: "entities.table.column.image" }),
      dataIndex: "images",
      width: 25,
      render: (value: Array<Image>) => <DataTableImageColumn images={value} imageTypes={[ImageTypes.Logo]} />,
    },
    {
      key: EntityTableColumns.EntityId,
      title: formatMessage({ id: "entities.table.column.entityId" }),
      dataIndex: "entityId",
      copyable: false,
      width: 300,
    },
    {
      key: EntityTableColumns.ExternalId,
      title: formatMessage({ id: "entities.table.column.externalId" }),
      dataIndex: "externalId",
      copyable: false,
      width: 150,
    },
    {
      key: EntityTableColumns.NameFullLocal,
      title: formatMessage({ id: "entities.table.column.nameFullLocal" }),
      dataIndex: "nameFullLocal",
      sorter: true,
    },
    {
      key: EntityTableColumns.NameFullLatin,
      title: formatMessage({ id: "entities.table.column.nameFullLatin" }),
      dataIndex: "nameFullLatin",
      width: 150,
      sorter: true,
    },
    {
      key: EntityTableColumns.AgeGroup,
      title: formatMessage({ id: "entities.table.column.ageGroup" }),
      dataIndex: "ageGroup",
      width: 90,
    },
    {
      key: EntityTableColumns.Gender,
      title: formatMessage({ id: "entities.table.column.gender" }),
      dataIndex: "gender",
      width: 90,
    },
    {
      key: EntityTableColumns.Discipline,
      title: formatMessage({ id: "entities.table.column.discipline" }),
      dataIndex: "discipline",
      width: 90,
    },
    {
      key: EntityTableColumns.Standard,
      title: formatMessage({ id: "entities.table.column.standard" }),
      dataIndex: "standard",
      width: 90,
    },
    {
      key: EntityTableColumns.Status,
      title: formatMessage({ id: "entities.table.column.status" }),
      dataIndex: "status",
      width: 90,
    },
    {
      key: EntityTableColumns.EntityGroupId,
      title: formatMessage({ id: "entities.table.column.entityGroup" }),
      dataIndex: "entityGroupId",
      copyable: false,
      width: 90,
      render: (_, row) => {
        return <div>{row.entityGroup?.nameFullLocal}</div>;
      },
    },
    {
      key: EntityTableColumns.Representing,
      title: formatMessage({ id: "entities.table.column.representing" }),
      dataIndex: "representing",
      width: 90,
    },
    {
      key: EntityTableColumns.InternationalReference,
      title: formatMessage({ id: "entities.table.column.internationalReference" }),
      dataIndex: "internationalReference",
      width: 90,
    },
    {
      key: EntityTableColumns.Grade,
      title: formatMessage({ id: "entities.table.column.grade" }),
      dataIndex: "grade",
      width: 90,
    },
    {
      key: EntityTableColumns.CodeLocal,
      title: formatMessage({ id: "entities.table.column.codeLocal" }),
      dataIndex: "codeLocal",
      copyable: false,
      width: 90,
    },
    {
      key: EntityTableColumns.CodeLatin,
      title: formatMessage({ id: "entities.table.column.codeLatin" }),
      dataIndex: "codeLatin",
      copyable: false,
      width: 90,
    },
  ];
};
